import { useCallback } from 'react'

interface UseSmoothScrollOptions {
  offset?: number
  behavior?: ScrollBehavior
}

export function useSmoothScroll({ offset = 0, behavior = 'smooth' }: UseSmoothScrollOptions = {}) {
  const scrollTo = useCallback((target: string | number) => {
    if (typeof target === 'number') {
      window.scrollTo({ top: target - offset, behavior })
      return
    }

    const element = document.querySelector(target)
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.scrollY
      window.scrollTo({ top: elementPosition - offset, behavior })
    }
  }, [offset, behavior])

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior })
  }, [behavior])

  const scrollToElement = useCallback((element: HTMLElement | null) => {
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.scrollY
      window.scrollTo({ top: elementPosition - offset, behavior })
    }
  }, [offset, behavior])

  return { scrollTo, scrollToTop, scrollToElement }
}
